import React, { useState, useEffect, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Grid,
  Button,
  Divider,
  TextField,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import ParentCard from "src/components/shared/ParentCard";
import { IconArrowBack } from "@tabler/icons";
import { useFormik } from "formik";
import BulkImeiService from "src/service/bulkdeviceadd";
import swal from "sweetalert";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    to: "/addbulkvehicle",
    title: "Upload vehicle",
  },
  {
    title: "Vehicle Table",
  },
];

const VehicleTable = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [vehicleData, setVehicleData] = useState([]);
  const [okData, setOkData] = useState([]);
  const [notOkData, setNotOkData] = useState([]);

  const initialVehicleData = useMemo(
    () => location.state?.vehicleData || [],
    [location.state?.vehicleData]
  );

  useEffect(() => {
    // Filter initial data into ok and not ok
    const ok = initialVehicleData.filter((item) => item.status === 0);
    const notOk = initialVehicleData.filter((item) => item.status !== 0);

    setOkData(ok);
    setNotOkData(notOk);
    setVehicleData(initialVehicleData);
  }, [initialVehicleData]);

  const handleInputChange = (index, field, value) => {
    const updatedVehicleData = [...notOkData];
    updatedVehicleData[index][field] = value;
    setNotOkData(updatedVehicleData);
  };

  const sessionData = JSON.parse(localStorage.getItem("user"));

  const initialValues1 = {
    vehicle_data: okData,
    c_by: sessionData?.data?.id || "",
  };

  const formik = useFormik({
    initialValues: initialValues1,
    onSubmit: async (values) => {
      let result = okData.map((ok) => [
        ok.vehicle_no.toUpperCase(),
        ok.erv_no.toUpperCase(),
        ok.imei_no,
        ok.district_code,
        ok.vehicle_type.toUpperCase(),
      ]);

      try {
        const res = await BulkImeiService.add_bulk_vehicle_data({
          vehicle_data: result,
          c_by: sessionData?.data?.id,
        });
        swal("Success", res.message, "success");
        setTimeout(() => {
          navigate("/bulkvehiclelist");
        }, 1000);
      } catch (error) {
        swal("Error", error.message, "error");
      }
    },
  });

  const handleVerify = async () => {
    try {
      const formattedVehicleData = notOkData.map((item) => [
        item.vehicle_no,
        item.erv_no,
        item.imei_no,
        item.district_code,
        item.vehicle_type,
      ]);

      const verificationResult = await BulkImeiService.verify_vehicle_data({
        vehicle_data: formattedVehicleData,
        c_by: sessionData?.data?.id || "",
      });

      if (verificationResult.status === 200) {
        const updatedOkData = [];
        const updatedNotOkData = [];

        verificationResult.data.forEach((dataItem, index) => {
          if (dataItem.status === 0) {
            updatedOkData.push(notOkData[index]);
          } else {
            updatedNotOkData.push(notOkData[index]);
          }
        });

        setOkData((prevOkData) => [...prevOkData, ...updatedOkData]);
        setNotOkData(updatedNotOkData);
      } else {
        console.error("Verification failed:", verificationResult.message);
      }
    } catch (error) {
      console.error("Error verifying data:", error);
    }
  };

  const handleSubmit = () => {
    formik.handleSubmit();
  };

  return (
    <div>
      <Breadcrumb title="Vehicle Table" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Upload vehicle
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/addbulkvehicle");
              }}
              style={{ marginLeft: "10px" }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        {notOkData.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow style={{ textAlign: "center", fontSize: "16px" }}>
                <TableCell>Vehicle No</TableCell>
                <TableCell>ERV No</TableCell>
                <TableCell>IMEI No</TableCell>
                <TableCell>District</TableCell>
                <TableCell>Vehicle Type</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {notOkData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <TextField
                      value={row.vehicle_no}
                      onChange={(e) =>
                        handleInputChange(index, "vehicle_no", e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      value={row.erv_no}
                      onChange={(e) =>
                        handleInputChange(index, "erv_no", e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell style={{ width: "20%" }}>
                    <TextField
                      value={row.imei_no}
                      onChange={(e) =>
                        handleInputChange(index, "imei_no", e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      value={row.district_code}
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "district_code",
                          e.target.value
                        )
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      value={row.vehicle_type}
                      onChange={(e) =>
                        handleInputChange(index, "vehicle_type", e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell style={{ width: "20%" }}>
                    <TextField
                      value={
                        row.status === 1
                          ? "Imei No Duplicate"
                          : row.status === 2
                          ? "vehicle No Duplicate"
                          : row.status === 3
                          ? "Both Imei & Vehicle No"
                          : "NA"
                      }
                      inputProps={{ readOnly: true }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography
            variant="h6"
            color="error"
            colSpan="7"
            mt={3}
            style={{ textAlign: "center" }}
          >
            No Duplicate data Found . Ready To Submit.
          </Typography>
        )}
        {/* Display verified data in a separate section */}
        {okData.length > 0 && (
          <>
            <Typography
              variant="h6"
              color="primary"
              mt={3}
              style={{ textAlign: "center" }}
            >
              Verified Data
            </Typography>
            <Table>
              <TableHead>
                <TableRow style={{ textAlign: "center", fontSize: "16px" }}>
                  <TableCell>Vehicle No</TableCell>
                  <TableCell>ERV No</TableCell>
                  <TableCell>IMEI No</TableCell>
                  <TableCell>District</TableCell>
                  <TableCell>Vehicle Type</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {okData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.vehicle_no}</TableCell>
                    <TableCell>{row.erv_no}</TableCell>
                    <TableCell>{row.imei_no}</TableCell>
                    <TableCell>{row.district_code}</TableCell>
                    <TableCell>{row.vehicle_type}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        )}

        <Grid
          container
          justifyContent="flex-end"
          sx={{ marginTop: "20px", paddingRight: "20px" }}
        >
          {notOkData.length > 0 ? (
            <Button
              variant="contained"
              color="primary"
              onClick={handleVerify}
              style={{ marginRight: "10px" }}
            >
              Verify
            </Button>
          ) : null}
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={notOkData.length > 0}
          >
            Submit
          </Button>
        </Grid>
      </ParentCard>
    </div>
  );
};

export default VehicleTable;
